export enum ComplianceRequestType {
    ShippingRequest = 1,
    ComplianceRequest = 2,
    VendorAdmin = 3
}
